const e=1024,o=24,t=1e3,c=60,n=60;export{e as BYTES_IN_KILOBYTE,o as HOURS_PER_DAY,t as MILLISECONDS_PER_SECOND,c as MINUTES_PER_HOUR,n as SECONDS_PER_MINUTE};
//# sourceMappingURL=number.constants.js.map
